import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { CatAndSubCatDefaultCategoryFragmentDoc } from './CatAndSubCatDefaultCategory.generated'
import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './purchasePlus_graphql'

export const GetCatAndSubCatSubCategoriesDocument = gql`
  query GetCatAndSubCatSubCategories(
    $after: String
    $before: String
    $filters: CategoriesQueryFiltersInput
    $first: Int
    $last: Int
    $sorts: [CategoriesQuerySortsInput!]
  ) {
    categories(after: $after, before: $before, filters: $filters, first: $first, last: $last, sorts: $sorts) {
      edges {
        node {
          ...CatAndSubCatDefaultCategory
        }
      }
      pageInfo {
        ...PurchasePlusPageInfo
      }
    }
  }
  ${CatAndSubCatDefaultCategoryFragmentDoc}
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetCatAndSubCatSubCategoriesQuery, Types.GetCatAndSubCatSubCategoriesQueryVariables>
